<script lang="ts">
export default {
  props: {
    invalid: {
      type: Boolean,
      required: false,
    },
    valid: {
      type: Boolean,
      required: false,
    },
    inputType: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
    },
    modelValue: {
      type: String,
      required: true,
    },
    debounceDelay: {
      type: Number,
      required: false,
      default: 300,
    },
    required: {
      type: Boolean,
      required: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },

    autofocus: { type: Boolean, default: true },

    design: {
      type: Object,
      required: false,
      default: () => ({
        backgroundColor: "white",
        color: "color",
        fontSize: "fontSize",
        width: "width",
        height: "height",
        padding: "padding",
      }),
    },
  },
  emits: ["update:modelValue", "input-focus", "input-blur"],
  data() {
    return {
      debounceTimeout: null as ReturnType<typeof setTimeout> | null,
      isFocused: false,
    };
  },
  methods: {
    onInput(event: Event) {
      const target = event.target as HTMLInputElement;
      const value = target.value;

      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }

      this.debounceTimeout = setTimeout(() => {
        this.$emit("update:modelValue", value);
      }, this.debounceDelay);
    },
    handleFocus() {
      this.isFocused = true;
      this.$emit("input-focus");
    },
    handleBlur() {
      this.isFocused = false;
      this.$emit("input-blur");
    },
  },
  beforeUnmount() {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
  },
};
</script>

<template>
  <div class="input-container">
    <input
      required
      class="input"
      :class="{ invalid: invalid, valid: valid }"
      :value="modelValue"
      :readonly="readonly"
      :type="inputType"
      :placeholder="placeholder"
      :autofocus="autofocus"
      :style="{
        backgroundColor: design.backgroundColor,
        color: design.color,
        width: design.width,
        height: design.height,
        fontSize: design.fontSize,
        padding: design.padding,
      }"
      @input="onInput"
      @focus="handleFocus"
      @blur="handleBlur"
    />
  </div>
</template>

<style scoped>
.input-container {
  position: relative;
  margin-bottom: 1.5rem;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
}
.input {
  border: 1px solid transparent;
  border-radius: 10px;
  background-color:#2E333D;
  padding: 1rem;
  color: var(--black);
  outline: none;
  transition: border 0.2s ease-in-out;
  font-size: 0.8rem;
  font-weight: 600;
}
.input::placeholder {
  color: var(--text-low-emphasis);
}

.input:focus {
  border-color: #818498;

}


.input.invalid {
  border: 1px solid var(--error);
}

.input.valid {
  border: 1px solid var(--success);
}


@media screen and (max-height: 800px) {
  .input {
    padding: 1rem 0.8rem 0.5rem 0.8rem;
    font-size: small;
  }
  .input-container {
    margin-bottom: 0.6rem;
  }
  .floating-label {
    font-size: small;
  }
}
</style>
